__turbopack_context__.v({
  "Button": "index-module__CVhaDa__Button",
  "Close": "index-module__CVhaDa__Close",
  "Content": "index-module__CVhaDa__Content",
  "Description": "index-module__CVhaDa__Description",
  "Text": "index-module__CVhaDa__Text",
  "Title": "index-module__CVhaDa__Title",
  "Toast": "index-module__CVhaDa__Toast",
  "Viewport": "index-module__CVhaDa__Viewport",
});
